import React from 'react';
import { Link } from 'react-router-dom';

const CONTACT = {
  address: 'Unit 1 Bowling Green Lane, Grimsby DN32 9DE UK',
  email: 'agcashcarry@gmail.com',
  phone: '+44 01472 355588',
};

const VALUES = [
  { title: 'Quality products', desc: 'We stock a wide range of trusted brands and products for trade and business.' },
  { title: 'Competitive pricing', desc: 'Member-only prices kept up to date so you can quote and order with confidence.' },
  { title: 'Local & reliable', desc: 'Based in Grimsby, we serve local businesses with a straightforward, no-fuss approach.' },
  { title: 'No commitment', desc: 'Free to join. Browse the catalog, check prices, and order when it suits you.' },
];

export function AboutUs() {
  return (
    <div className="bg-slate-50/30">
      {/* ——— Hero ——— */}
      <section className="bg-primary border-b border-slate-700/50">
        <div className="container mx-auto px-6 sm:px-8 py-20 sm:py-28">
          <p className="section-label text-amber-400/95 mb-4">About us</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight max-w-3xl">
            Your trusted cash & carry in Grimsby
          </h1>
          <p className="mt-6 text-lg text-slate-300 max-w-2xl">
            We supply quality products at competitive trade prices. Create a free account to access our full catalog and member-only pricing.
          </p>
        </div>
      </section>

      {/* ——— Who we are ——— */}
      <section className="bg-white border-b border-slate-200/80">
        <div className="container mx-auto px-6 sm:px-8 py-20 sm:py-28">
          <div className="max-w-3xl">
            <p className="section-label mb-4">Who we are</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-primary tracking-tight">
              Built for trade. Priced for you.
            </h2>
            <p className="mt-6 text-slate-600 text-lg leading-relaxed">
              Cash & Carry is your local supplier in Grimsby, offering a wide range of products at competitive trade prices. 
              We keep our catalog and pricing up to date so businesses can browse, quote, and order with confidence — 
              no paperwork, no minimum order, and no commitment required.
            </p>
            <p className="mt-6 text-slate-600 text-lg leading-relaxed">
              Whether you run a shop, a café, or any trade that needs regular supplies, we aim to make ordering simple: 
              sign up for free, log in to see member prices, and browse our products by category. Weekly promotions and 
              new additions are clearly marked so you never miss a deal.
            </p>
          </div>
        </div>
      </section>

      {/* ——— What we offer ——— */}
      <section className="bg-slate-50/60 border-b border-slate-200/80">
        <div className="container mx-auto px-6 sm:px-8 py-20 sm:py-28">
          <p className="section-label text-center mb-3">What we offer</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary tracking-tight text-center mb-16">
            Everything you need in one place
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
            {VALUES.map((v, i) => (
              <div
                key={i}
                className="rounded-2xl border border-slate-200/90 bg-white p-6 shadow-sm hover:shadow-md transition-shadow"
              >
                <h3 className="font-bold text-primary text-lg">{v.title}</h3>
                <p className="mt-3 text-slate-600 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-14 text-center">
            <Link
              to="/products"
              className="inline-flex items-center justify-center px-8 py-4 rounded-xl font-semibold bg-primary text-white hover:bg-primary-light transition-colors shadow-lg shadow-slate-900/10"
            >
              View our products
            </Link>
          </div>
        </div>
      </section>

      {/* ——— Contact ——— */}
      <section className="bg-white border-b border-slate-200/80">
        <div className="container mx-auto px-6 sm:px-8 py-20 sm:py-28">
          <p className="section-label text-center mb-3">Get in touch</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-primary tracking-tight text-center mb-14">
            Visit or contact us
          </h2>
          <div className="max-w-2xl mx-auto space-y-6">
            <div className="flex gap-4 rounded-2xl border border-slate-200/90 bg-slate-50/50 p-6">
              <span className="flex-shrink-0 w-10 h-10 rounded-xl bg-amber-500/15 flex items-center justify-center">
                <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </span>
              <div>
                <p className="font-semibold text-primary">Address</p>
                <p className="mt-1 text-slate-600">{CONTACT.address}</p>
              </div>
            </div>
            <div className="flex gap-4 rounded-2xl border border-slate-200/90 bg-slate-50/50 p-6">
              <span className="flex-shrink-0 w-10 h-10 rounded-xl bg-amber-500/15 flex items-center justify-center">
                <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </span>
              <div>
                <p className="font-semibold text-primary">Email</p>
                <a href={`mailto:${CONTACT.email}`} className="mt-1 text-slate-600 hover:text-amber-600 transition-colors">
                  {CONTACT.email}
                </a>
              </div>
            </div>
            <div className="flex gap-4 rounded-2xl border border-slate-200/90 bg-slate-50/50 p-6">
              <span className="flex-shrink-0 w-10 h-10 rounded-xl bg-amber-500/15 flex items-center justify-center">
                <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </span>
              <div>
                <p className="font-semibold text-primary">Phone</p>
                <a href={`tel:${CONTACT.phone.replace(/\s/g, '')}`} className="mt-1 text-slate-600 hover:text-amber-600 transition-colors">
                  {CONTACT.phone}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
